import { set, setProp } from '@/utils/vuex'
import Vue from 'vue'

export default {
  // Timers
  setCurrentTimestamp: set('currentTimestamp'),
  setFetchedTimestamp: set('fetchedTimestamp'),
  setIntervalId: set('intervalId'),

  // Data
  setField: set('field'),
  setFieldProp: setProp('field'),
  setResult: set('result'),
  setLoading: set('loading'),
  setCsvUploadStatus: set('csvUploadStatus'),
  updateCustomer ({ result }, { data, index }) {
    Vue.set(result, index, { ...result[index], ...data })
  },
  updateCustomerTank (state, commitData) {
    let tank = state.result[commitData.customerIndex].tanks[commitData.tankIndex]
    Object.assign(tank, commitData.reqData)
  },
  createCustomerTank ({ result }, { customerIndex, data }) {
    const tanks = result[customerIndex].tanks
    Vue.set(tanks, tanks.length, { ...data.reqData, id: data.tankId })
  },
  deleteOneTank ({ result }, { customerIndex, tankIndex }) {
    Vue.delete(result[customerIndex].tanks, tankIndex)
  },
  addSensor ({ result }, { serialNo, customerIndex, tankIndex }) {
    const customer = result[customerIndex]
    Vue.set(customer.sensors, customer.sensors.length, serialNo)
    Vue.set(customer.tanks, tankIndex, { ...customer.tanks[tankIndex], serialNo, activateStatus: 1 })
  },
  deleteSensor ({ result }, { serialNo, customerIndex, tankIndex }) {
    const customer = result[customerIndex]
    const sensorIndex = customer.sensors.indexOf(serialNo)
    customer.sensors.splice(sensorIndex, 1)
    Vue.set(customer.tanks, tankIndex, { ...customer.tanks[tankIndex], serialNo: '', activateStatus: undefined })
  },
  changeSensor ({ result }, { from, to, customerIndex, tankIndex }) {
    const customer = result[customerIndex]
    const sensorIndex = customer.sensors.indexOf(from)
    Vue.set(customer.sensors, sensorIndex, to)
    Vue.set(customer.tanks, tankIndex, { ...customer.tanks[tankIndex], serialNo: to })
  }
}
